import clsx from 'clsx';
import { matchPath } from 'react-router-dom';

export const SIDEBAR_LINK_BUTTON_STYLE = [
  'mb-1.5',
  '!px-3',
  'flex',
  'h-10',
  'flex-row',
  'items-center',
  'justify-start',
  'bg-primary-gray',
  'text-secondary-steel-blue',
  'cursor-pointer',
  'text-sm',
  'font-normal',
  'hover:bg-secondary-light-gray',
  'rounded-md',
  'hover:text-accent-dark-gray',
  'md:w-52',
  'w-[210px]'
].join(' ');

export const getSidebarButtonClassName = (isActive: boolean, className?: string) =>
  clsx(SIDEBAR_LINK_BUTTON_STYLE, className, {
    relative: isActive,
    '!bg-secondary-light-gray': isActive,
    '!fill-primary-blue': isActive,
    '!font-bold': isActive,
    '!text-primary-blue': isActive,
    'before:absolute': isActive,
    'before:bottom-2': isActive,
    'before:right-0': isActive,
    'before:top-2': isActive,
    'before:w-[2.5px]': isActive,
    'before:rounded-l-sm': isActive,
    'before:bg-primary-blue': isActive
  });

export const isSidebarPathActive = (pathname: string, path?: string) => {
  if (!path) {
    return false;
  }

  return !!matchPath({ path, end: false }, pathname);
};
